"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupChip = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _useUnmountEffect = require("@react-hookz/web/cjs/useUnmountEffect/useUnmountEffect");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _lodestarIcons = require("@smartsheet/lodestar-icons");
var _react = _interopRequireWildcard(require("react"));
var _noop = require("../../../../constants/noop");
var _useTheme = require("../../../../theme/utils/useTheme");
var _chip = require("../../../chip");
var _chipTheme = require("../../../chip/styled/chipTheme");
var _flyout = require("../../../flyout");
var _tooltip = require("../../../tooltip");
var _optionToString = require("../../utils/optionToString");
var _OptionContactCard = require("../shared/OptionContactCard");
const GroupChip = _ref => {
  let {
    className,
    option,
    optionProps,
    chipType,
    onViewMembers,
    onExpandMembers
  } = _ref;
  const [isContactCardOpen, setIsContactCardOpen] = (0, _react.useState)(false);
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const {
    tooltipProps,
    targetProps
  } = (0, _tooltip.useTooltip)({
    placement: "bottom-start",
    hasArrow: false,
    offset: {
      distance: 0
    },
    targetRef: optionProps.ref
  });
  const avatarProps = {
    size: "xSmall",
    color: {
      backgroundColor: (0, _designTokensReact.color)("color--background--info--weaker"),
      textColor: (0, _designTokensReact.color)("color--text--neutral--strong")
    },
    content: /*#__PURE__*/_react.default.createElement(_lodestarIcons.ShareIcon, {
      size: "xxSmall"
    }),
    tabIndex: -1,
    role: "presentation",
    "aria-hidden": true
  };
  function onCardOpen() {
    window.addEventListener("keydown", onKeyDown);
    setIsContactCardOpen(true);
  }
  function onCardClose() {
    window.removeEventListener("keydown", onKeyDown);
    setIsContactCardOpen(false);
  }
  function onKeyDown(e) {
    if (e.key === "Escape") {
      onCardClose();
    }
  }
  (0, _useUnmountEffect.useUnmountEffect)(() => window.removeEventListener("keydown", onKeyDown));
  if (optionProps.showTooltip) {
    return /*#__PURE__*/_react.default.createElement(_chip.AvatarChip, (0, _extends2.default)({
      avatarProps: avatarProps,
      className: className
    }, optionProps, targetProps, {
      size: _chipTheme.chipTheme.chip.size(themeMode),
      chipType: chipType
    }), /*#__PURE__*/_react.default.createElement(_tooltip.Tooltip, tooltipProps, /*#__PURE__*/_react.default.createElement(_tooltip.TooltipBody, null, optionProps.tooltipContent)), (0, _optionToString.optionToString)(option));
  } else {
    return /*#__PURE__*/_react.default.createElement(_chip.AvatarChip, (0, _extends2.default)({
      avatarProps: avatarProps,
      className: className
    }, optionProps, targetProps, {
      onMouseEnter: onCardOpen,
      size: _chipTheme.chipTheme.chip.size(themeMode),
      onMouseLeave: onCardClose,
      chipType: chipType
    }), /*#__PURE__*/_react.default.createElement(_flyout.Flyout, (0, _extends2.default)({}, tooltipProps, {
      onCloseRequested: onCardClose,
      isOpen: tooltipProps.isOpen || isContactCardOpen
    }), /*#__PURE__*/_react.default.createElement(_OptionContactCard.OptionContactCard, {
      onMouseEnter: _noop.noop,
      onMouseLeave: _noop.noop,
      option: option,
      onViewMembers: onViewMembers,
      onExpandMembers: onExpandMembers,
      showExpandMembers: true
    })), (0, _optionToString.optionToString)(option));
  }
};
exports.GroupChip = GroupChip;
//# sourceMappingURL=GroupChip.js.map